import React from "react";
import "./About.css";
import PublicHeader from "../../components/public/PublicHeader";
import PublicFooter from "../../components/public/PublicFooter";

function About() {
    return (
        <div className="about-page">
            <PublicHeader />
            <section className="public-hero">
                <div className="about-container">
                    <header className="about-hero">
                        <h1>About Zinea</h1>
                        <p className="about-hero-subtitle">Deeptech for everyday living.</p>
                    </header>
                </div>
            </section>
            <main className="about-content">
                <div className="about-container">
                    <section className="about-section">
                        <h2>About Zinea</h2>
                        <p>
                            Zinea is a deeptech initiative building AI systems that understand how people
                            live and help improve everyday life over time.
                        </p>
                    </section>

                    <section className="about-section">
                        <h2>Lifestyle Intelligence</h2>
                        <p>
                            Life is shaped by emotions, energy, time, habits, and work — all interacting together.
                            Zinea uses AI to model these interactions and adapt digital systems to reduce friction,
                            improve balance, and support sustainable living.
                        </p>
                        <p className="about-emphasis">This is not personalization. It is personal lifestyle modeling.</p>
                    </section>

                    <section className="about-section">
                        <h2>Tech Foundation</h2>
                        <p>Zinea is built on long-term behavioral modeling and adaptive AI.</p>
                        <p>
                            Our platform includes a patented system for calculating a Composite Happiness Index,
                            combining personal and professional life signals to reflect how life truly feels.
                        </p>
                        <p>
                            Beyond happiness, Zinea models energy, time, habits, and life alignment to understand
                            lifestyle sustainability.
                        </p>
                    </section>

                    <section className="about-section">
                        <h2>Why Deeptech</h2>
                        <p>Zinea is deeptech because it focuses on:</p>
                        <ul className="about-list">
                            <li>Longitudinal pattern learning</li>
                            <li>Multi-dimensional human modeling</li>
                            <li>Outcome-based AI systems</li>
                            <li>Explainable, privacy-first design</li>
                        </ul>
                        <p>Our systems improve with time — learning what works for each individual.</p>
                    </section>

                    <section className="about-section">
                        <h2>Social Impact</h2>
                        <p>Zinea’s impact is built into the technology.</p>
                        <p>
                            By helping people detect lifestyle instability early and design more sustainable routines,
                            Zinea works to prevent burnout and disengagement at scale.
                        </p>
                        <p>Access to lifestyle intelligence should not depend on privilege.</p>
                    </section>

                    <section className="about-section">
                        <h2>Digital First, Physically Supported</h2>
                        <p>Zinea is mobile-first.</p>
                        <p>
                            When insight alone is not enough, optional physical tools help reinforce intelligence in
                            real-world environments — supporting focus, recovery, and consistency.
                        </p>
                    </section>

                    <section className="about-section">
                        <h2>Trust & Responsibility</h2>
                        <ul className="about-list">
                            <li>Privacy-first by design</li>
                            <li>No ads or data selling</li>
                            <li>Transparent, explainable intelligence</li>
                            <li>Respectful, minimal interventions</li>
                        </ul>
                        <p>
                            Zinea does not diagnose or treat medical conditions. It supports better lifestyle design.
                        </p>
                    </section>

                    <section className="about-section about-vision">
                        <div className="about-vision-inner">
                            <p className="about-vision-label">Vision</p>
                            <h2>The future is not more apps — it’s better intelligence.</h2>
                            <p>Zinea is building systems that help people design better lives, over time.</p>
                            <p className="about-footer-line">
                                AI-powered lifestyle intelligence to help people live better.
                            </p>
                        </div>
                    </section>
                </div>
            </main>
            <PublicFooter />
        </div>
    );
}

export default About;
